var d = [];
for (var r = 0; r < 256; ++r)
  d.push((r + 256).toString(16).slice(1));
function c(n, u = 0) {
  return (d[n[u + 0]] + d[n[u + 1]] + d[n[u + 2]] + d[n[u + 3]] + "-" + d[n[u + 4]] + d[n[u + 5]] + "-" + d[n[u + 6]] + d[n[u + 7]] + "-" + d[n[u + 8]] + d[n[u + 9]] + "-" + d[n[u + 10]] + d[n[u + 11]] + d[n[u + 12]] + d[n[u + 13]] + d[n[u + 14]] + d[n[u + 15]]).toLowerCase();
}
var e, p = new Uint8Array(16);
function y() {
  if (!e && (e = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !e))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return e(p);
}
var i = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const o = {
  randomUUID: i
};
function m(n, u, a) {
  if (o.randomUUID && !n)
    return o.randomUUID();
  n = n || {};
  var t = n.random || (n.rng || y)();
  return t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128, c(t);
}
export {
  m as v
};
//# sourceMappingURL=v4-CPnJi9UN.mjs.map
